<ng-template #contentRef>
    <ng-content></ng-content>
</ng-template>
@switch (type) {
    @case ("menu") {
        <span nz-typography [nzEllipsis]="true"
            ><ng-container *ngTemplateOutlet="contentRef"></ng-container
        ></span>
    }
    @case ("button") {
        <span nz-typography
            ><strong
                ><ng-container
                    *ngTemplateOutlet="contentRef"></ng-container></strong
        ></span>
    }
    @case ("header") {
        <h2 nz-typography>
            <ng-container *ngTemplateOutlet="contentRef"></ng-container>
        </h2>
    }
    @case ("title") {
        <h4 nz-typography>
            <ng-container *ngTemplateOutlet="contentRef"></ng-container>
        </h4>
    }
    @case ("subtitle") {
        <h5 nz-typography>
            <ng-container *ngTemplateOutlet="contentRef"></ng-container>
        </h5>
    }
    @case ("info") {
        <span nz-typography class="pf-text-info">
            <ng-container *ngTemplateOutlet="contentRef"></ng-container>
        </span>
    }
    @default {
        <span
            nz-typography
            style="margin-bottom: auto"
            [ngClass]="{ 'pf-text-ellipses': ellipsis }"
            [nzType]="nzType">
            <ng-container *ngTemplateOutlet="contentRef"></ng-container>
        </span>
    }
}
